import React from 'react';
import arbitration from '../images/arbitration.jpeg';
import criminal from '../images/criminal.jpeg';
import realEstate from '../images/realEstate.jpeg';
const slideImages = [
    {
      url: arbitration,
      caption: 'JUSTICE IN LAW IS OUR PRIORITY'
    },
    {
      url: realEstate,
      caption: ' TRANSFORMING LEGAL SERVICES'
     
    },
    {
      url: criminal,
      caption: ` CLIENT'S SATISFACTION IS OUR GOAL`
     
    },
  ];
  export default slideImages;